import React,{Component} from 'react';
import "./style.less";
import {NavBar, Toast, ListView, Icon, Modal} from "antd-mobile";
import {connect} from "react-redux";
import {shuntList} from "../../../service/homeService";
import {closeOrder} from "../../../service/shuntService";

let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const header = require('../../../common/image/user.png');
const noOrder = require('../../../common/image/noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ShuntList extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
            showModal:false,
            shuntOrderCombinationId:"",
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        shuntList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };

    //提示modal
    modalShow=(id)=>{
        this.setState({
            showModal:true,
            shuntOrderCombinationId:id
        })
    };
    //关闭接口
    delete = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "shuntOrderCombinationId":this.state.shuntOrderCombinationId,
                "closeType": 2
            }
        };
        closeOrder(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info('撤回成功');
                let listParams={
                    token: this.props.userInfo.token,
                    data:{
                        pageSize: pageSize,
                        pageNum: 1
                    }
                };
                this.setState({OrderListData:[]});
                this._getOrderList(listParams);
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无代下单记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
  
    
    
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID}>
                <div className="top">
                    <span>订单号  {i.orderaNum}</span>
                    <p>{i.status}</p>
                </div>
                <div className="middle">
                    <div className="driverInfo">
                        <div className="header">
                            <img src={header}/>
                        </div>
                        <div>
                            <p className="fontW600 marginB600">{i.driverName}</p>
                            <div className="bgblue">{i.carNum}</div>
                        </div>
                        <div>
                            <div className="price marginB600">{i.price}元<span className="gray">人数：{i.peopleNum}人</span></div>
                            <div>建议时间：{i.estimatedTiemOfDeparture}</div>
                        </div>

                    </div>
                    {i.orderDetails ? i.orderDetails.map((res,i)=>(
                        <div className="location" key={i}>
                        <div className="shift">
                            <span>{res.shiftName}</span>
                            <span>行程时间：{res.startTime}</span>
                        </div>
                        {res.orderType == '送' ? <div className="send">
                            <div><i className="icon iconfont icondaixiadanchufadi"></i>{res.vicinageStationName}</div> 
                        </div>:null}
                        <div>
                            <i className={res.orderType == '接' ? 'icon iconfont icondaixiadanchufadi' : 'icon iconfont icondaixiadanmudedi'}></i>
                            {res.address}
                        </div>
                        {res.orderType == '接' ?  <div className="deliver">
                            <div><i className="icon iconfont icondaixiadanmudedi"></i>{res.vicinageStationName}</div>
                        </div> :null}
                    </div>
                    )) : null}
                </div>
                <div className="bottom" onClick={()=>this.modalShow(i.id)}>
                    <button>撤回订单</button>
                </div>
            </div>
        )
        return(
            <div className="shuntList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >分流记录</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={200}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                           
                </div>

                <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[
                        { text: '不撤回', onPress: () => { this.setState({showModal:!this.state.showModal}); } },
                        { text: '确认撤回', onPress: () => { this.setState({showModal:!this.state.showModal});this.delete() } }
                    ]}
                >
                    <div className="modalTitle">
                        <div>是否确认撤回？</div>
                        <div>取消订单后将拆散重组</div>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/ShuntList/index.js